import React, { Fragment, useState } from "react";
import "./trendGraph.scss";

/*
  partyAcronym: '',
  partyColor: '',
  partyPercent: 0
*/

const PartiesTrend = {
  left: [
    "PSOE",
    "UNIDAS PODEMOS",
    "ERC-SOBIRANISTES",
    "EH Bildu",
    "PACMA",
    "EN MAREA"
  ],
  right: ["PP", "Cs", "VOX", "JxCAT-JUNTS", "EAJ-PNV", "COMPROMÍS 2019"]
};

const orderData = data => {
  let ordererData = {
    left: {
      percent: 0,
      seats: 0,
      parties: []
    },
    others: {
      percent: 0,
      seats: 0,
      parties: []
    },
    right: {
      percent: 0,
      seats: 0,
      parties: []
    }
  };
  data.partiesResult.forEach(party => {
    if (PartiesTrend.left.indexOf(party.partyAcronym) > -1) {
      ordererData.left.parties.push(party);
      ordererData.left.percent += party.seats / data.totalSeats;
      ordererData.left.seats += party.seats;
    } else if (PartiesTrend.right.indexOf(party.partyAcronym) > -1) {
      ordererData.right.parties.push(party);
      ordererData.right.percent += party.seats / data.totalSeats;
      ordererData.right.seats += party.seats;
    } else {
      ordererData.others.parties.push(party);
      ordererData.others.percent += party.seats / data.totalSeats;
      ordererData.others.seats += party.seats;
    }
  });
  ordererData.right.parties.reverse();
  return ordererData;
};


const TrendGraph = ({ data }) => {
  
  const [mousePos, setMousePos] = useState({ x: null, y: null });
  const [selectedParty, setSelectedParty] = useState();
  
  const mouseEnter = (e, party) => {
    setMousePos({ x: e.clientX, y: e.clientY });
    setSelectedParty(party);
  }
  
  const mouseLeave = () => {
    setMousePos({ x: null, y: null });
  }

  if (!data.partiesResult) {
    return <div>Loading</div>;
  }
  const ordererData = orderData(data);
  return (
    <Fragment>
      <div className="trendGraph">
        <div className="trendGraph_container">
          <div className="trendGraph_bars">
            <div
              className="trendGraph_bar trendGraph_bar_left"
              style={{
                width: (ordererData.left.seats / data.totalSeats) * 100 + "%"
              }}
            >
              <h3 className="trendGraph_bar_title">
                <span className="trendGraph_bar_title_txt">
                  BLOQUE DE IZQUIERDA ({ordererData.left.seats})
                </span>
              </h3>
              {ordererData.left.parties.map(party => {
                return (
                  <div
                    className="trendGraph_bar_content"
                    key={party.partyAcronym}
                    style={{
                      backgroundColor: party.partyColor,
                      width:
                        (party.seats / ordererData.left.seats) * 100 + "%"
                    }}
                    onMouseMove={e => mouseEnter(e, party)}
                    onMouseLeave={() => mouseLeave()}
                  >
                    <span className="trendGraph_bar_txt">{party.seats}</span>
                  </div>
                );
              })}
            </div>
            <div
              className="trendGraph_bar trendGraph_bar_center"
              style={{
                width:
                  (ordererData.others.seats / data.totalSeats) * 100 + "%"
              }}
            >
              <h3 className="trendGraph_bar_title"> </h3>
              {ordererData.others.parties.map(party => {
                return (
                  <div
                    className="trendGraph_bar_content"
                    key={party.partyAcronym}
                    style={{
                      backgroundColor: party.partyColor,
                      width:
                        (party.seats / ordererData.others.seats) * 100 + "%"
                    }}
                    onMouseMove={e => mouseEnter(e, party)}
                    onMouseLeave={() => mouseLeave()}
                  >
                    <span className="trendGraph_bar_txt">{party.seats}</span>
                  </div>
                );
              })}
            </div>
            <div
              className="trendGraph_bar trendGraph_bar_right"
              style={{
                width: (ordererData.right.seats / data.totalSeats) * 100 + "%"
              }}
            >
              <h3 className="trendGraph_bar_title">
                <span className="trendGraph_bar_title_txt">
                  BLOQUE DE DERECHA ({ordererData.right.seats})
                </span>
              </h3>
              {ordererData.right.parties.map(party => {
                return (
                  <div
                    className="trendGraph_bar_content"
                    key={party.partyAcronym}
                    style={{
                      backgroundColor: party.partyColor,
                      width:
                        (party.seats / ordererData.right.seats) * 100 + "%"
                    }}
                    onMouseMove={e => mouseEnter(e, party)}
                    onMouseLeave={() => mouseLeave()}
                  >
                    <span className="trendGraph_bar_txt">{party.seats}</span>
                  </div>
                );
              })}
            </div>
            <div className="trendGraph_line">
              <div className="trendGraph_line_txt">
                Mayoría absoluta
                <span className="trendGraph_line_number">
                  {Math.trunc(data.totalSeats / 2 + 1)}
                </span>
              </div>
            </div>
          </div>
        </div>
        {mousePos.x && (
          <div
            className="trendGraph_tooltip"
            style={{
              position: "fixed",
              left: mousePos.x + 15,
              top: mousePos.y - 5,
              borderLeft: "10px solid " + selectedParty.partyColor
            }}
          >
            <h3 className="partyName">{selectedParty.partyAcronym}</h3>
            <p className="partySeats">{selectedParty.seats} escaños</p>
            <p className="partyVotes">
              {Number(selectedParty.votesPercent).toLocaleString("es")} %{" "}
            </p>
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default TrendGraph;
